import { ContentContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import CovidTrackerHeadlines from '@reuters-graphics/covid-tracker-headlines';
import Headlines from './Headlines';
import Title from './Title';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const HeadlineNews = ({ stepDuration = 1500, delay = 1500, globalStatistics, hasFetched }) => {
  const locale = useContext(LocaleContext);
  const content = useContext(ContentContext);

  const covidTrackerHeadlines = new CovidTrackerHeadlines({
    globalStatistics: globalStatistics,
    smartText: content.common.headlines,
    locale,
  });

  const headlines = covidTrackerHeadlines.getHeadlines(3);

  return (
    <div className={classnames(component)}>
      <div className='headline-well clearfix'>
        <Title
          countries={headlines.map(h => h.smartText.context.country)}
          stepDuration={stepDuration}
          delay={delay}
        />
        <Headlines
          stepDuration={stepDuration}
          delay={delay}
          headlines={headlines}
          hasFetched={hasFetched}
          lastUpdated={globalStatistics.lastUpdated}
        />
      </div>
    </div>
  );
};

export default HeadlineNews;
